import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';

import { isMovableInk } from 'modules/movableInk/utils';
import { useModalContext } from 'utils/contexts/modal';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { Modal } from '../types/modal';

export enum ImageModalType {
  CreativeLibrary = 'creativeLibrary',
  MovableInk = 'movableInk',
}

export const useHandleImageModal = () => {
  const { setSelectedImage, setSelectedImageAnchor } = useWYSIWYGContext();
  const { showModal } = useModalContext();
  const { MovableInk } = useSelector(selectFeatureFlags);

  return (node?: HTMLImageElement, modalType = ImageModalType.CreativeLibrary) => {
    const isMovableInkImage = MovableInk && isMovableInk(node?.currentSrc || '');
    const parentNode = node?.parentNode as HTMLAnchorElement;

    // sets selected image to applicable node
    setSelectedImage(node);
    if (isMovableInkImage && parentNode?.tagName === 'A' && isMovableInk(parentNode?.href || '')) {
      setSelectedImageAnchor(parentNode);
    } else {
      setSelectedImageAnchor();
    }

    if (isMovableInkImage) {
      showModal(Modal.MovableInk);
    } else if (!node) {
      showModal(
        modalType === ImageModalType.CreativeLibrary || !MovableInk
          ? Modal.CreativeLibrary
          : Modal.MovableInk,
      );
    } else {
      showModal(Modal.CreativeLibrary);
    }
  };
};
